function formatPrice(price) {
  return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function formatGram(number) {
  if (Number.isInteger(number)) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return number.toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}

/** استخراج پیام قابل‌نمایش از خطای axios معامله */
function getTradeErrorMessage(error, fallback = 'خطا در ثبت معامله') {
  const data = error && error.response && error.response.data;
  const serverMessage =
    (data && (data.message || data.error)) ||
    (error && error.response && error.response.message) ||
    null;

  if (serverMessage) {
    return serverMessage;
  }

  // وقتی CORS/شبکه بدنهٔ ۴۰۰ را نمی‌دهد، axios می‌گوید Network Error
  const raw = String((error && error.message) || '');
  if (!error || !error.response || /network error/i.test(raw)) {
    return 'ثبت معامله انجام نشد. اگر پروفایل ناقص است آن را تکمیل کنید، وگرنه اتصال اینترنت را بررسی نمایید.';
  }

  return raw || fallback;
}

function isProfileIncompleteError(errorOrMessage) {
  const msg =
    typeof errorOrMessage === 'string'
      ? errorOrMessage
      : getTradeErrorMessage(errorOrMessage, '');
  const code =
    errorOrMessage &&
    errorOrMessage.response &&
    errorOrMessage.response.data &&
    errorOrMessage.response.data.code;
  return (
    code === 'profile_incomplete' ||
    /پروفایل|اسم و فامیل|نام و نام خانوادگی/i.test(String(msg || ''))
  );
}

function hasCompleteProfileName(firstName, familyName) {
  const first = firstName == null ? '' : String(firstName).trim();
  const family = familyName == null ? '' : String(familyName).trim();
  return first !== '' && family !== '';
}

export {
  formatPrice,
  formatGram,
  getTradeErrorMessage,
  isProfileIncompleteError,
  hasCompleteProfileName,
};

